import React, {Fragment} from "react"
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"


const TabListContent = [
    "Todos",
    "Software",
    "Seguridad Web",
    "Soluciones IT",
    "Tecnología",
    "Ciberseguridad",
];

const AllContent = [
    {
        img: "blog-12",
        tag: "Investigación , Tecnología",
        desc: "Google está eliminando la sección de Películas y TV de la Play Store",
        authorName: "Samir Jam",
        date: "21 Jan 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-13",
        tag: "Investigación , Tecnología",
        desc: "Twitter pide a los accionistas aprobar la adquisición de $44 mil millones de Elon Musk",
        authorName: "Anisa Kdar",
        date: "02 Aug 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-14",
        tag: "Investigación , Tecnología",
        desc: "Donde las Mentes se Encuentran con las Máquinas: El Futuro de la Robótica",
        authorName: "Samir Jam",
        date: "21 Jan 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-17",
        tag: "Investigación , Tecnología",
        desc: "Fermyon quiere reinventar la forma en que los programadores desarrollan microservicios",
        authorName: "Hamina",
        date: "09 Feb 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-15",
        tag: "Investigación , Tecnología",
        desc: "Anunciando la agenda completa de TC Sessions: Robótica este julio",
        authorName: "Anisa Kdar",
        date: "17 Sep 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-16",
        tag: "Investigación , Tecnología",
        desc: "El pulso en tu mano: la startup API-first Vivanta aspira a ser el Plaid de la salud",
        authorName: "Samir Jam",
        date: "21 jan 2021",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-20",
        tag: "Investigación , Tecnología",
        desc: "Kibo School obtiene $2M para ofrecer títulos STEM en línea a estudiantes en África",
        authorName: "Chris Hams",
        date: "19 Jun 2222",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-18",
        tag: "Investigación , Tecnología",
        desc: 'Los términos de los acuerdos cambian en una recesión. Esto es lo que debes tener en cuenta',
        authorName: "Samir Jam",
        date: "21 Jan 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-19",
        tag: "Investigación , Tecnología",
        desc: "Neuron7 recauda $10M para ayudar a los agentes de servicio al cliente a encontrar soluciones",
        authorName: "Hamina Hasan",
        date: "04 Oct 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }
];
const SoftwareContent = [
    {
        img: "blog-14",
        tag: "Investigación , Tecnología",
        desc: "Donde las Mentes se Encuentran con las Máquinas: El Futuro de la Robótica",
        authorName: "Samir Jam",
        date: "21 Jan 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-17",
        tag: "Investigación , Tecnología",
        desc: "Fermyon quiere reinventar la forma en que los programadores desarrollan microservicios",
        authorName: "Hamina",
        date: "09 Feb 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-15",
        tag: "Investigación , Tecnología",
        desc: "Anunciando la agenda completa de TC Sessions: Robótica este julio",
        authorName: "Anisa Kdar",
        date: "17 Sep 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-16",
        tag: "Investigación , Tecnología",
        desc: "El pulso en tu mano: la startup API-first Vivanta aspira a ser el Plaid de la salud",
        authorName: "Samir Jam",
        date: "21 jan 2021",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    },  {
        img: "blog-19",
        tag: "Investigación , Tecnología",
        desc: "Neuron7 recauda $10M para ayudar a los agentes de servicio al cliente a encontrar soluciones",
        authorName: "Hamina Hasan",
        date: "04 Oct 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }
];
const WebSecurityContent = [
     {
        img: "blog-14",
        tag: "Investigación , Tecnología",
        desc: "Donde las Mentes se Encuentran con las Máquinas: El Futuro de la Robótica",
        authorName: "Samir Jam",
        date: "21 Jan 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-17",
        tag: "Investigación , Tecnología",
        desc: "Fermyon quiere reinventar la forma en que los programadores desarrollan microservicios",
        authorName: "Hamina",
        date: "09 Feb 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-15",
        tag: "Investigación , Tecnología",
        desc: "Anunciando la agenda completa de TC Sessions: Robótica este julio",
        authorName: "Anisa Kdar",
        date: "17 Sep 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-16",
        tag: "Investigación , Tecnología",
        desc: "El pulso en tu mano: la startup API-first Vivanta aspira a ser el Plaid de la salud",
        authorName: "Samir Jam",
        date: "21 jan 2021",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-19",
        tag: "Investigación , Tecnología",
        desc: "Neuron7 recauda $10M para ayudar a los agentes de servicio al cliente a encontrar soluciones",
        authorName: "Hamina Hasan",
        date: "04 Oct 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }
];
const ITContent = [
    {
        img: "blog-12",
        tag: "Investigación , Tecnología",
        desc: "Google está eliminando la sección de Películas y TV de la Play Store",
        authorName: "Samir Jam",
        date: "21 Jan 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-13",
        tag: "Investigación , Tecnología",
        desc: "Twitter pide a los accionistas aprobar la adquisición de $44 mil millones de Elon Musk",
        authorName: "Anisa Kdar",
        date: "02 Aug 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    },  {
        img: "blog-15",
        tag: "Investigación , Tecnología",
        desc: "Anunciando la agenda completa de TC Sessions: Robótica este julio",
        authorName: "Anisa Kdar",
        date: "17 Sep 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    },  {
        img: "blog-18",
        tag: "Investigación , Tecnología",
        desc: 'Los términos de los acuerdos cambian en una recesión. Esto es lo que debes tener en cuenta',
        authorName: "Samir Jam",
        date: "21 Jan 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, 
];
const TechnologyContent = [
    {
        img: "blog-17",
        tag: "Investigación , Tecnología",
        desc: "Fermyon quiere reinventar la forma en que los programadores desarrollan microservicios",
        authorName: "Hamina",
        date: "09 Feb 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-15",
        tag: "Investigación , Tecnología",
        desc: "Anunciando la agenda completa de TC Sessions: Robótica este julio",
        authorName: "Anisa Kdar",
        date: "17 Sep 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-16",
        tag: "Investigación , Tecnología",
        desc: "El pulso en tu mano: la startup API-first Vivanta aspira a ser el Plaid de la salud",
        authorName: "Samir Jam",
        date: "21 jan 2021",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, 
];
const CyberSecurityContent = [
     {
        img: "blog-13",
        tag: "Investigación , Tecnología",
        desc: "Twitter pide a los accionistas aprobar la adquisición de $44 mil millones de Elon Musk",
        authorName: "Anisa Kdar",
        date: "02 Aug 2022",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-16",
        tag: "Investigación , Tecnología",
        desc: "El pulso en tu mano: la startup API-first Vivanta aspira a ser el Plaid de la salud",
        authorName: "Samir Jam",
        date: "21 jan 2021",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, {
        img: "blog-18",
        tag: "Investigación , Tecnología",
        desc: 'Los términos de los acuerdos cambian en una recesión. Esto es lo que debes tener en cuenta',
        authorName: "Samir Jam",
        date: "21 Jan 2020",
        icon1: "bi bi-person-plus",
        icon2: "i bi-clock"
    }, 
];

const BlogStyleThree = () => {
    return (
        <Fragment>
            <Tabs>
            <TabList className="row justify-content-center">
                <div className="col-xxl-10 text-center">
                    <div className="portfolio-menu mb-40">
                    {TabListContent.map((tab,i)=>(
                        <Tab key={i} className="gf_btn">{tab}</Tab>
                        ))}
                    </div>
                </div>
            </TabList>
                <TabPanel>
                  <ResponsiveMasonry columnsCountBreakPoints={{350: 1,  767.98: 2, 991.98: 3}}>
                      <Masonry gutter="30px">
                        {AllContent.map((val,i)=>(
                            <div key={i} className="blog-style-two style-three mb-35">
                                <div className="blog-thumb">
                                    <img className="w-100" src={`assets/img/blog/${val.img}.jpg`} alt="img" />
                                    </div>
                                    <div className="blog-content">
                                    <div className="blog-tag pb-10">
                                        {val.tag}
                                    </div>
                                    <h3><Link className="blog-title" to="/blog-details">{val.desc}</Link></h3>
                                    <div className="blog-meta">
                                        <a href="#" className="mr-lg-5 mr-20"><i className={val.icon1} /> {val.authorName}</a>
                                        <a href="#"><i className={val.icon2} /> {val.date}</a>
                                    </div>
                                </div>
                            </div>
                            ))}
                      </Masonry>
                  </ResponsiveMasonry>
                </TabPanel>
                <TabPanel>  
                  <ResponsiveMasonry columnsCountBreakPoints={{350: 1,  767.98: 2, 991.98: 3}}>
                      <Masonry gutter="30px">
                      {SoftwareContent.map((val,i)=>(
                           <div key={i} className="blog-style-two style-three mb-35">
                                <div className="blog-thumb">
                                    <img className="w-100" src={`assets/img/blog/${val.img}.jpg`} alt="img" />
                                    </div>
                                    <div className="blog-content">
                                    <div className="blog-tag pb-10">
                                        {val.tag}
                                    </div>
                                    <h3><Link className="blog-title" to="/blog-details">{val.desc}</Link></h3>
                                    <div className="blog-meta">
                                        <a href="#" className="mr-lg-5 mr-20"><i className={val.icon1} /> {val.authorName}</a>
                                        <a href="#"><i className={val.icon2} /> {val.date}</a>
                                    </div>
                                </div>
                            </div>
                          ))}
                      </Masonry>
                  </ResponsiveMasonry>
                </TabPanel>
                <TabPanel>
                <ResponsiveMasonry columnsCountBreakPoints={{350: 1,  767.98: 2, 991.98: 3}}>
                      <Masonry gutter="30px">
                      {WebSecurityContent.map((val,i)=>(
                           <div key={i} className="blog-style-two style-three mb-35">
                                <div className="blog-thumb">
                                    <img className="w-100" src={`assets/img/blog/${val.img}.jpg`} alt="img" />
                                    </div>
                                    <div className="blog-content">
                                    <div className="blog-tag pb-10">
                                        {val.tag}
                                    </div>
                                    <h3><Link className="blog-title" to="/blog-details">{val.desc}</Link></h3>
                                    <div className="blog-meta">
                                        <a href="#" className="mr-lg-5 mr-20"><i className={val.icon1} /> {val.authorName}</a>
                                        <a href="#"><i className={val.icon2} /> {val.date}</a>
                                    </div>
                                </div>
                            </div>
                          ))}
                      </Masonry>
                  </ResponsiveMasonry>
                </TabPanel>
                <TabPanel>
                <ResponsiveMasonry columnsCountBreakPoints={{350: 1,  767.98: 2, 991.98: 3}}>
                      <Masonry gutter="30px">
                      {ITContent.map((val,i)=>(
                           <div key={i} className="blog-style-two style-three mb-35">
                                <div className="blog-thumb">
                                    <img className="w-100" src={`assets/img/blog/${val.img}.jpg`} alt="img" />
                                    </div>
                                    <div className="blog-content">
                                    <div className="blog-tag pb-10">
                                        {val.tag}
                                    </div>
                                    <h3><Link className="blog-title" to="/blog-details">{val.desc}</Link></h3>
                                    <div className="blog-meta">
                                        <a href="#" className="mr-lg-5 mr-20"><i className={val.icon1} /> {val.authorName}</a>
                                        <a href="#"><i className={val.icon2} /> {val.date}</a>
                                    </div>
                                </div>
                            </div>
                          ))}
                      </Masonry>
                  </ResponsiveMasonry>
                </TabPanel>
                <TabPanel>
                <ResponsiveMasonry columnsCountBreakPoints={{350: 1,  767.98: 2, 991.98: 3}}>
                      <Masonry gutter="30px">
                      {TechnologyContent.map((val,i)=>(
                           <div key={i} className="blog-style-two style-three mb-35">
                                <div className="blog-thumb">
                                    <img className="w-100" src={`assets/img/blog/${val.img}.jpg`} alt="img" />
                                    </div>
                                    <div className="blog-content">
                                    <div className="blog-tag pb-10">
                                        {val.tag}
                                    </div>
                                    <h3><Link className="blog-title" to="/blog-details">{val.desc}</Link></h3>
                                    <div className="blog-meta">
                                        <a href="#" className="mr-lg-5 mr-20"><i className={val.icon1} /> {val.authorName}</a>
                                        <a href="#"><i className={val.icon2} /> {val.date}</a>
                                    </div>
                                </div>
                            </div>
                          ))}
                      </Masonry>
                  </ResponsiveMasonry>
                </TabPanel>
                <TabPanel>
                <ResponsiveMasonry columnsCountBreakPoints={{350: 1,  767.98: 2, 991.98: 3}}>
                      <Masonry gutter="30px">
                      {CyberSecurityContent.map((val,i)=>(
                           <div key={i} className="blog-style-two style-three mb-35">
                                <div className="blog-thumb">
                                    <img className="w-100" src={`assets/img/blog/${val.img}.jpg`} alt="img" />
                                    </div>
                                    <div className="blog-content">
                                    <div className="blog-tag pb-10">
                                        {val.tag}
                                    </div>
                                    <h3><Link className="blog-title" to="/blog-details">{val.desc}</Link></h3>
                                    <div className="blog-meta">
                                        <a href="#" className="mr-lg-5 mr-20"><i className={val.icon1} /> {val.authorName}</a>
                                        <a href="#"><i className={val.icon2} /> {val.date}</a>
                                    </div>
                                </div>
                            </div>
                          ))}
                      </Masonry>
                  </ResponsiveMasonry>
                </TabPanel>
                
        </Tabs>
        </Fragment>
    )
}

export default BlogStyleThree


